import { render, staticRenderFns } from "./InjuryComplexityChart.vue?vue&type=template&id=271dee68&scoped=true"
import script from "./InjuryComplexityChart.vue?vue&type=script&lang=js"
export * from "./InjuryComplexityChart.vue?vue&type=script&lang=js"
import style0 from "./InjuryComplexityChart.vue?vue&type=style&index=0&id=271dee68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271dee68",
  null
  
)

export default component.exports